<div class="market-place-settings-msg"><p-messages [(value)]="systemMsg" [enableService]="false" [closable]="false"></p-messages></div>
<div class="draft-notification-bar" [ngStyle]="{display: showDraftNotification ? 'block' : 'none'}">
    <p-messages [(value)]="draftMsg" [enableService]="false">
        <ng-template pTemplate>
            <div class="draft-message-toast">
                <div class="flex align-items-center">
                    <span class="draft-message">Draft message saved</span>
                </div>
                <div class="flex align-items-center">
                    <button class="draft-discard-btn mr-2" (click)="discardDraft()">Discard</button>
                    <i class="pi pi-times draft-close-icon cursor-pointer" (click)="closeDraftNotification()"></i>
                </div>
            </div>
        </ng-template>
    </p-messages>
</div>
<div *ngIf="authGuard.loading$ | async" class="index-loader text-center"><img src="assets/images/landing-page/loading-more.svg" alt="Loader" width="" height="" /></div>
<app-global-popup></app-global-popup>
<app-global-loader></app-global-loader>
<router-outlet></router-outlet>
<script async src="https://www.googletagmanager.com/gtag/js?id=G-JTYF0VJXS6"></script>
<script>
  window.dataLayer = window.dataLayer || [];
  function gtag(){dataLayer.push(arguments);}
  gtag('js', new Date());

  gtag('config', 'G-JTYF0VJXS6');
</script>
<audio loop id="outgoing-call">
  <source src="assets/sounds/outgoing_ringtone.mp3" type="audio/mp3" />
</audio>
<audio loop id="incoming-call">
  <source src="assets/sounds/incoming_ringtone.mp3" type="audio/mp3" />
</audio>
